module.exports = __webpack_public_path__ + "static/img/panel_enterprise_climbing.cf94bef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rescuelist/panel_enterprise_climbing.png
// module id = 57N1
// module chunks = 1